import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState } from 'react';
import { Popover } from '@mui/material';
import get from 'lodash/get';
import classNames from "classnames";
import { JourneysSelectors, useAppSelector } from "conversional-journey";
import { MUI_ICONS } from "../icons/MuiIcons";
import createComponentsFromObject from "../../utilities/components/createComponentsFromObject";
import { getStyles } from "./FormFieldTooltip.styles";
var Icon = MUI_ICONS['HelpOutlineIcon'];
function FormFieldTooltip(_a) {
    var tooltip = _a.tooltip, tooltipClassName = _a.tooltipClassName, popoverContentClassName = _a.popoverContentClassName;
    var theme = useAppSelector(JourneysSelectors.selectTheme);
    var classes = getStyles(theme);
    var _b = useState(false), popoverOpen = _b[0], setPopoverOpen = _b[1];
    var popoverAnchor = useRef(null);
    var onMouseEnter = function () { return setPopoverOpen(true); };
    var onMouseLeave = function () { return setPopoverOpen(false); };
    var togglePopover = function () {
        setPopoverOpen(!popoverOpen);
    };
    if (!tooltip)
        return null;
    return (_jsxs("div", { className: classNames(classes.tooltipContainer, tooltipClassName), children: [_jsx(Popover, { open: popoverOpen && Boolean(popoverAnchor.current), className: classes.popover, anchorEl: popoverAnchor.current, classes: {
                    paper: classNames(classes.popoverContent, popoverContentClassName),
                }, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                }, disableAutoFocus: true, PaperProps: {
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave,
                    modifiers: [
                        {
                            name: 'preventOverflow',
                            options: {
                                boundary: 'window'
                            },
                        },
                    ],
                }, children: typeof tooltip === 'string'
                    ? tooltip
                    : createComponentsFromObject(get(tooltip, 'content')) }), _jsxs("a", { ref: popoverAnchor, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onClick: togglePopover, style: { display: 'inline-block', padding: '12px' }, children: [_jsx("span", { style: {
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            left: 0,
                            top: 0,
                            zIndex: -1,
                        } }), _jsx(Icon, {})] })] }));
}
export default (FormFieldTooltip);
